export default String.raw`
const PurchaseHistory = (() => {
    'use strict';
    const toCurrencySymbol = (currencyCode) => {
        switch (currencyCode) {
            case 'PLN':
                return 'zł';
            case 'EUR':
                return '€';
            case 'USD':
                return '$';
            case 'GBP':
                return '£';
            default:
                return currencyCode;
        }
    };

    const getPurchaseHistory = async (productId) => {
        const data = {
            __action: 'sync/exec',
            __csrf: __CSRF,
            worker: 'erpData',
            message: JSON.stringify({
                command: 'CDN.eShop_GetCustomerLastPricesForProduct',
                parameters: {
                    LanguageId: __lngId,
                    ProductId: productId
                }
            })
        };

        try {
            const response = await $.post('', data);

            if (response?.action?.Code == 108) {
                app.temporaryPopupMessage(undefined, __translations.FunctionUnavailable, response.action.Type);
                return;
            }

            if(response?.action?.Code != 0) {
                app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
                return;
            }

            const purchaseHistory = response?.action?.Object[0]?.Result;
    
            if (!purchaseHistory || purchaseHistory.length === 0) {
                return [];
            }

            return purchaseHistory.map(purchase => ({
                ...purchase,
                Currency: toCurrencySymbol(purchase.Currency),
                Date: new Date(purchase.Date).toLocaleDateString()
            }));
        } catch(error) {
            console.error("Error fetching purchase history:", error);
        }
    };

    return {
        getPurchaseHistory
    };
})();

const PurchaseHistoryUI = (() => {
    'use strict';
    const button = document.querySelector('.check-purchase-history-js');

    if (!button) {
        return;
    }

    $('body').on('click', '.check-purchase-history-js', withSpinner(async (e) => {
        const productId = $(e.currentTarget).data('product-id');
    
        if (!productId) {
            return;
        }

        const popup = document.querySelector('.history-popup-js');
        const purchaseHistory = await PurchaseHistory.getPurchaseHistory(productId);

		if (!purchaseHistory) {
            return;
        }
		
        if (purchaseHistory.length === 0) {
            popup.showModal();
            return;
        }

        let tableRows = '';
        purchaseHistory.forEach((purchase) => {
            tableRows += '<tr class="table__row"><td class="table-data__cell table__cell">' +
                        purchase.ERPInvoiceNumber + '</td><td class="table-data__cell table__cell">' +
                        purchase.Date + '</td><td class="table-data__cell table__cell">' +
                        purchase.Price + ' ' + purchase.Currency + '</td><td class="table-data__cell table__cell">' +
                        purchase.Quantity + ' ' + purchase.Unit + '</td></tr>';
        });
        $('.history-popup-table-content-js').html(tableRows);
        popup.showModal();
    }));
})();
`